import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconRegularViewReport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.5 17.786c0 .353.28.643.625.643H20.75c.691 0 1.25.574 1.25 1.285S21.441 21 20.75 21H5.125C3.399 21 2 19.562 2 17.786v-13.5C2 3.576 2.56 3 3.25 3s1.25.576 1.25 1.286v13.5zm10.883-4.878a1.223 1.223 0 0 1-1.766 0l-2.242-2.302-3.492 3.588a1.223 1.223 0 0 1-1.766 0 1.307 1.307 0 0 1 0-1.816l4.375-4.5a1.223 1.223 0 0 1 1.766 0L14.5 10.18l4.117-4.23a1.222 1.222 0 0 1 1.766 0 1.309 1.309 0 0 1 0 1.815l-5 5.143z",
		fill: "currentColor",
		fillRule: "nonzero"
	})
});
export default SvgIconRegularViewReport;
